import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';

const AuthContext = React.createContext(null);

function AuthProvider({ children }) {
  const [token, setToken] = useState('');

  const handleLogout = () => {
    setToken(null);
  };

  const value = useMemo(
    () => ({
      token,
      onLogout: handleLogout
    }),
    []
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

AuthProvider.propTypes = {
  children: PropTypes.element.isRequired
};

export { AuthProvider, AuthContext };
